export default __webpack_public_path__ + "static/media/icon-help.ccfaaa4a.svg";